<template>
  <div style="">
    <el-drawer size="100%" :visible.sync="drawer" @close="close">
      <div
        style="
          min-width: 1000px;
          height: 99vh;
          overflow: hidden;
          position: relative;
          font-size: 14px;
        "
      >
        <el-card v-loading="loading">
          <el-row
            style="
              margin-top: 10px;
              display: flex;
              align-items: center;
              height: 40px;
            "
          >
            <el-button size="mini" type="primary" @click="close"
              ><i class="el-icon-back" style="margin-right: 10px"></i>
              后退前页</el-button
            >
            <div style="margin-left: 20px">
              项目名称：
              <span
                style="font-weight: bold; font-size: 18px; margin-right: 20px"
                >{{ ProjectInfo.Name }}</span
              >
              设备分类：
              <span style="font-weight: bold; font-size: 18px">{{
                TreeName
              }}</span>
            </div>

            <el-button
              size="mini"
              type="primary"
              style="margin-left: 20px"
              @click="saveDesignPattern(true)"
              >保存模板</el-button
            >
          </el-row>
          <el-row style="margin-top: 20px" :gutter="20">
            <el-col :span="4">
              <el-card
                style="
                  height: calc(100vh - 110px);
                  overflow-y: auto;
                  width: 100%;
                "
                :body-style="{
                  padding: 0,
                }"
              >
                <div style="position: relative; padding: 20px">
                  <div
                    style="
                      position: sticky;
                      top: 0px;
                      left: 0px;
                      z-index: 999;
                      height: 60px;
                      display: flex;
                      align-items: center;
                      background-color: #fff;
                    "
                    v-if="leftDataCopy.length > 0"
                  >
                    <el-input
                      placeholder="输入关键字进行过滤"
                      v-model="filterText"
                      @input="leftDataSearch"
                    >
                    </el-input>
                  </div>
                  <div style="margin-top: 10px">
                    <el-button
                      v-for="item in leftData"
                      :key="item.FiledKey + item.FiledName"
                      style="width: 100%; margin: 5px 0; position: relative"
                      @click="addItem(item)"
                      :class="[
                        item.FiledKey === ItemInfo.FiledKey
                          ? 'ButtonActive'
                          : '',
                      ]"
                    >
                      <span style="color: red" v-if="item.IsEnable"
                        >* {{ item.FieldName }}</span
                      >
                      <span v-else>{{ item.FieldName }}</span>
                      <span
                        :class="['deviceFoundation', 'el-icon-price-tag']"
                        v-if="item.IsFoundation == 1"
                      ></span>
                    </el-button>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="16">
              <el-card
                style="
                  height: calc(100vh - 110px);
                  overflow-y: auto;
                  width: 100%;
                "
              >
                <el-tabs
                  v-model="activeName"
                  type="card"
                  @tab-click="handleClick"
                >
                  <el-tab-pane
                    v-for="itemI in DeviceTabList"
                    :key="itemI.DeviceTab"
                    :label="itemI.DeviceTabName"
                    :name="itemI.DeviceTab"
                  >
                    <!-- //字段信息 -->
                    <div
                      v-if="itemI.DeviceTab !== 'DocumentInformation'"
                      style="display: flex; width: 100%; flex-wrap: wrap"
                    >
                      <div
                        v-for="item in infoObj[itemI.DeviceTab]"
                        :key="item.FiledKey"
                        :style="`width:${
                          100 / item.width
                        }%;margin-bottom:10px;padding-left:10px;padding-right:10px;box-sizing: border-box;padding-top:2px;padding-bottom:2px;cursor: pointer`"
                        :class="`${
                          item.FiledKey === ItemInfo.FiledKey ? 'active' : ''
                        }`"
                      >
                        <div
                          style="display: flex; width: 100%; cursor: pointer"
                          @click="addItem(item)"
                        >
                          <span
                            style="
                              display: inline-block;
                              width: 100px;
                              display: flex;
                              align-items: center;
                            "
                          >
                            <span style="color: red" v-if="item.disabled"
                              >*</span
                            >
                            {{ item.FieldName }}
                          </span>
                          <el-input
                            v-model="item.value"
                            placeholder="请输入内容"
                            v-if="item.ComponentType === 'InputText'"
                            style="width: calc(100% - 100px)"
                            type="textarea"
                            :rows="item.rows || 1"
                            resize="none"
                            size="mini"
                          ></el-input>
                          <el-input
                            v-model="item.value"
                            placeholder="请输入内容"
                            v-if="item.ComponentType === 'InputNumber'"
                            style="width: calc(100% - 100px)"
                            type="number"
                            resize="none"
                            size="mini"
                          ></el-input>
                          <el-date-picker
                            v-model="item.value"
                            type="date"
                            placeholder="选择日期"
                            v-if="item.ComponentType === 'DatePicker'"
                            size="mini"
                            value-format="yyyy-MM-dd"
                            style="width: calc(100% - 100px)"
                          >
                          </el-date-picker>
                          <el-radio-group
                            v-model="item.value"
                            v-if="item.ComponentType === 'Radio'"
                            style="
                              width: calc(100% - 100px);
                              height: 28px;
                              display: flex;
                              align-items: center;
                              line-height: 28px;
                            "
                            size="mini"
                          >
                            <el-radio
                              v-for="val in item.Source
                                ? JSON.parse(item.Source)
                                : []"
                              :label="val.value"
                              :key="val.value"
                            >
                              {{ val.value }}</el-radio
                            >
                          </el-radio-group>
                          <el-select
                            v-model="item.value"
                            v-if="item.ComponentType === 'Select'"
                            placeholder="请选择"
                            style="width: calc(100% - 100px)"
                            size="mini"
                            clearable
                          >
                            <el-option
                              v-for="val in item.Source
                                ? JSON.parse(item.Source)
                                : []"
                              :key="val.value"
                              :label="val.value"
                              :value="val.value"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>
                    <!-- 文档信息 -->
                    <div
                      v-if="itemI.DeviceTab === 'DocumentInformation'"
                      style="display: flex; width: 100%; flex-wrap: wrap"
                    >
                      <div
                        v-for="(item) in infoObj[itemI.DeviceTab]"
                        :key="item.FiledKey"
                        :style="`width:${
                          100 / item.width
                        }%;margin-bottom:10px;padding-left:10px;padding-right:10px;box-sizing: border-box;cursor: pointer`"
                        @click="addItem(item)"
                      >
                      
                        <el-table
                          style="width: 100%"
                          :data="
                            item.device_TypeTwoDocuments.filter((vall) =>
                              item.cList.includes(vall.Type)
                            )
                          "
                          :class="`${
                            item.FiledKey === ItemInfo.FiledKey ? 'active' : ''
                          }`"
                        >
                          <el-table-column
                            prop="TypeName"
                            :label="item.FieldName"
                            :resizable="false"
                          >
                            <template slot-scope="scope">
                              <span>
                                <span
                                  style="color: red"
                                  v-if="scope.row.disabled"
                                  >*</span
                                >
                                {{ `${scope.row.TypeName}` }}</span
                              >
                              <el-popover
                                placement="bottom-start"
                                v-if="scope.row.Remark"
                                :open-delay="100"
                                width="200"
                                trigger="hover"
                                :content="scope.row.Remark"
                                popper-class="table-popper"
                              >
                                <i
                                  class="el-icon-question"
                                  slot="reference"
                                ></i>
                              </el-popover>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="Name"
                            label="文件名称"
                            :resizable="false"
                          ></el-table-column>
                          <el-table-column
                            prop="size"
                            label="文件大小"
                            :resizable="false"
                          ></el-table-column>
                          <el-table-column
                            prop="date"
                            label="上传日期"
                            :resizable="false"
                          ></el-table-column>
                        </el-table>
                      </div>

                    </div>
                  </el-tab-pane>
                </el-tabs>

 
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card
                style="
                  height: calc(100vh - 110px);
                  overflow-y: auto;
                  width: 100%;
                "
              >
                <div v-if="ItemInfo.FieldName">
                  <div
                    style="
                      text-align: center;
                      font-weight: bold;
                      font-size: 16px;
                    "
                  >
                    {{ ItemInfo.FieldName }}
                  </div>

                  <el-form
                    :model="ItemInfo"
                    size="mini"
                    label-position="left"
                    label-width="90px"
                    style="margin-top: 20px"
                    v-if="ItemInfo.FieldName"
                  >
                    <el-row :gutter="10">
                      
                      <el-col
                        :span="24"
                        v-if="activeName !== 'DocumentInformation'"
                      >
                        <el-form-item label="占用位数:">
                          <el-select
                            v-model="ItemInfo.width"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="(item, index) in widthList"
                              :key="item.value + index + ''"
                              :label="item.text"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :span="24"
                        v-if="activeName !== 'DocumentInformation'"
                      >
                        <el-form-item label="是否必填:">
                          <el-radio-group
                            v-model="ItemInfo.disabled"
                            :disabled="ItemInfo.IsEnable ? true : false"
                          >
                            <el-radio-button :label="1">是</el-radio-button>
                            <el-radio-button :label="0">否</el-radio-button>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :span="24"
                        v-if="ItemInfo.ComponentType === 'InputText'"
                      >
                        <el-form-item label="内容行数">
                          <el-select
                            v-model="ItemInfo.rows"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in rowsList"
                              :key="item"
                              :label="item"
                              :value="item"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :span="24"
                        v-if="ItemInfo.DeviceTab === 'DocumentInformation'"
                      >
                        <el-form-item label="文档类型:">
                          <el-select
                            v-model="ItemInfo.cList"
                            placeholder="请选择"
                            multiple
                          >
                            <el-option
                              v-for="(
                                item, index
                              ) in ItemInfo.device_TypeTwoDocuments"
                              :key="item.Type + index + ''"
                              :label="item.TypeName"
                              :value="item.Type"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col
                        v-if="ItemInfo.DeviceTab === 'DocumentInformation'"
                        :span="24"
                      >
                        <div
                          style="text-align: left"
                          v-for="(
                            item, index
                          ) in ItemInfo?.device_TypeTwoDocuments.filter(
                            (vall) => ItemInfo?.cList?.includes(vall.Type)
                          )"
                          :key="item.Type + index + ''"
                        >
                          <div style="margin-bottom: 10px; font-weight: bold">
                            {{ item.TypeName }}
                          </div>
                          <el-form-item label="必填:" size="mini">
                            <el-radio-group v-model="item.disabled" size="mini">
                              <el-radio-button :label="1">是</el-radio-button>
                              <el-radio-button :label="0">否</el-radio-button>
                            </el-radio-group>
                          </el-form-item>
                          <el-form-item label="排序:">
                            <el-input-number
                              v-model="item.Sort"
                              controls-position="right"
                              :min="0"
                              step-strictly
                            ></el-input-number>
                            <!-- <el-radio-group v-model="item.disabled" size="mini">
                              <el-radio-button :label="1">是</el-radio-button>
                              <el-radio-button :label="0">否</el-radio-button>
                            </el-radio-group> -->
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col
                        :span="24"
                        style="margin-bottom: 10px"
                        v-if="activeName === 'DocumentInformation'"
                      >
                        <el-button
                          style="width: 100%"
                          size="mini"
                          type="primary"
                          @click="SortSubDocument"
                          >保存文档排序</el-button
                        >
                      </el-col>
                      <el-col
                        :span="24"
                        v-if="ItemInfo.ComponentType === 'Select'||ItemInfo.ComponentType === 'Radio'"
                      >
                        <el-form-item label="组件内容:">
                          <el-button type="text" @click="ConfigComponentContent">配置组件内容</el-button>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-button
                          style="width: 100%"
                          size="mini"
                          type="danger"
                          @click="itemDetele"
                        >
                          <span v-if="activeName === 'DocumentInformation'"
                            >删除区块</span
                          >
                          <span v-else>删除</span>
                        </el-button>
                      </el-col>
                    </el-row>
                  </el-form>
                  <el-divider></el-divider>
                  <div></div>
                  <div
                    style="
                      text-align: center;
                      font-weight: bold;
                      font-size: 16px;
                    "
                  >
                    <span v-if="activeName === 'DocumentInformation'"
                      >区块排序</span
                    >
                    <span v-else>排序设置</span>
                  </div>
                  <div style="margin-top: 20px">
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        margin-bottom: 10px;
                      "
                      v-for="(item, index) in infoObj[activeName]"
                      :key="item.FiledKey + index"
                    >
                      <span style="width: 130px">{{ item.FieldName }}</span>
                      <!-- <el-input
                        v-model="item.sortIndex"
                        placeholder="请输入序号"
                        type="number"
                        size="mini"
                        :min="0"
                        style="width: calc(100% - 130px)"
                      ></el-input> -->
                      <el-input-number
                        v-model="item.sortIndex"
                        controls-position="right"
                        :min="0"
                        style="width: calc(100% - 130px)"
                        step-strictly
                      ></el-input-number>
                    </div>
                    <div style="margin-top: 20px">
                      <el-button
                        style="width: 100%"
                        size="mini"
                        type="primary"
                        @click="itemSortSave"
                        >保存排序</el-button
                      >
                    </div>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </el-drawer>
    <el-dialog title="保存模板" :visible.sync="SubVisible" width="30%">
      <div
        style="
          display: inline-block;

          display: flex;
          align-items: center;
        "
      >
        <span>是否为系统模板：</span>
        <el-radio-group v-model="IsTrueOrFalse">
          <el-radio-button :label="1">是</el-radio-button>
          <el-radio-button :label="0">否</el-radio-button>
        </el-radio-group>
      </div>
      <div style="margin-top: 10px">
        <span style="color: red">
          是：
          后续系统该设备分类将都为该模板，如已保存系统模板则会覆盖当前系统模板</span
        >
        <br />

        <span> 否： 只保存当前项目该设备分类模板</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SubVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="saveDesignPattern(false)"
          v-loading="loading"
          >保 存</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="配置组件内容" :visible.sync="ConfigComponentContentVisible" width="30%" :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
     <div style="height: 40px;" class="df aic jur">
      <el-button icon="el-icon-plus" @click="addOption">添加选项</el-button>
     </div>
     <div>
      <el-table :data="ComponentContentCopy" style="width: 100%" :height="450">
        <el-table-column prop="value" label="选项">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.value" autocomplete="off" placeholder="选项名称 "></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" width="100">
          <template slot-scope="scope">
            <el-button icon="el-icon-delete" type="danger" @click="ComponentContentCopy.splice(scope.$index,1)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
     </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ConfigComponentContentVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="SubConfigComponent"
        
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ConfigComponentContentVisible:false,
      ComponentContentCopy:[],
      SubVisible: false,
      IsTrueOrFalse: 0,
      drawer: false,
      TreeName: '',
      infoObj: {},
      DeviceTabList: [],
      widthList: [
        {
          text: '一行一位',
          value: 1,
        },
        {
          text: '一行二位',
          value: 2,
        },
        {
          text: '一行三位',
          value: 3,
        },
        {
          text: '一行四位',
          value: 4,
        },
      ],
      rowsList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],

      //基础信息列表
      BasicInformationList: [],
      //配置信息列表
      ConfigurationInformationList: [],
      //文档信息列表
      DocumentInformationList: [],
      ItemInfo: {},
      ClassifyValue: '',
      Classify: [],
      ProjectInfo: {},
      ProjectId: '',
      FomrInfo: {},
      RightSeletData: [],
      leftData: [],
      leftDataCopy: [],
      IsEnableData: [],
      selectValues: [],
      RightInfo: {},
      activeName: '1',
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      loading: false,
    }
  },
  props: {},
  components: {},
  methods: {
    addOption(){
      this.ComponentContentCopy.push({ value: '',
      name: ''})
    },
    SubConfigComponent(){
      this.ComponentContentCopy.forEach(item => {
        item.name = item.value
      })
      const values = this.ComponentContentCopy.map(item => (item.value || '').trim())
      const hasEmpty = values.some(v => !v)
      if (hasEmpty) {
        return this.$notify.warning('请填写完整')
      }
      const hasDuplicate = values.length !== new Set(values).size
      if (hasDuplicate) {
        return this.$notify.warning('选项名称不能重复')
      }
      this.ItemInfo.Source = JSON.stringify(this.ComponentContentCopy)
      this.ConfigComponentContentVisible = false
      console.log('000000000000000')
    },
    //配置组件内容
    ConfigComponentContent(){
      let arr = this.ItemInfo.Source?JSON.parse(this.ItemInfo.Source):[]
      this.ComponentContentCopy=[...arr]
      this.ConfigComponentContentVisible=true
    },
    openDesignPattern(ProjectId, TreeId, TreeName) {
      this.ProjectId = ProjectId || ''
      this.ClassifyValue = TreeId || ''
      this.TreeName = TreeName || ''
      console.log(ProjectId, TreeId, TreeName)
      this.drawer = true
      this.IsTrueOrFalse = 0
      if (this.ProjectId && this.ClassifyValue) {
        this.getInfo()
        this.changeCascader()
        this.getIsEnableData()
        // this.getClassify();
      }
    },
    close() {
      this.drawer = false
    },
    getIsEnableData() {
      this.$http
        .post(
          `Device_TypeWork/Device_TypeDictionaryDetail/GetDataListByMoreCondition`,
          {
            Search: [
              {
                Condition: 'DeviceType',
                Keyword: this.ClassifyValue,
              },
              {
                Condition: 'IsEnable',
                Keyword: 1,
              },
            ],
          }
        )
        .then((res) => {
          if (res.Success) {
            this.IsEnableData = res.Data
          }
        })
    },
    //根据分类获取设计详情
    getTemplateInfo(DeviceType) {
      this.loading = true
      this.$http
        .post(
          `/Device_TypeWork/Device_TypeTemplate/GetDeviceTypeTemplateData?ProjectId=${this.ProjectId}&DeviceType=${DeviceType}`
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.infoObj = res.Data.device_TypeTemplate.Content
              ? JSON.parse(res.Data.device_TypeTemplate.Content)
              : {}
          } else {
            if (this.DeviceTabList.length > 0) {
              this.DeviceTabList.forEach((item) => {
                this.$set(this.infoObj, item.DeviceTab, [])
              })
            }
            // this.$notify.error(res.Msg);
          }
        })
    },
    saveDesignPattern(isopen) {
      // console.log(this.infoObj, 'this.infoObj')
      // console.log(this.infoObj, 'this.infoObj')
      // console.log(this.BasicInformationList, 'this.basicInformationList')
      // console.log(
      //   this.ConfigurationInformationList,
      //   'this.configurationInformationList'
      // )
      // console.log(this.DocumentInformationList, 'this.documentInformationList')

      if (isopen) {
        this.SubVisible = true
        return
      }
      this.SubVisible = false
      this.loading = true
      let arr = []
      let disabledData = []
      for (const key in this.infoObj) {
        arr = [...arr, ...this.infoObj[key]]
        if (key !== 'DocumentInformation') {
          this.infoObj[key].forEach((item) => {
            if (item.IsEnable) {
              disabledData.push(item)
            }
          })
        }
      }
      let errArr = []
      this.IsEnableData.forEach((item) => {
        let obj = disabledData.find((val) => {
          return val.FiledKey == item.FiledKey
        })
        if (!obj) {
          errArr.push(item.FieldName)
        }
      })
      if (errArr.length > 0) {
        let str = errArr.join(',')
        this.$notify.error(`${str}，未选择，请检查模板`)
        this.loading = false
        return
      }

      this.$http
        .post(
          '/Device_TypeWork/Device_TypeTemplate/SaveDeviceTypeTemplateData',
          {
            IsTrueOrFalse: this.IsTrueOrFalse,
            device_TypeTemplate: {
              ProjectId: this.ProjectId,
              DeviceType: this.ClassifyValue,
              Content: JSON.stringify(this.infoObj),
            },
            device_TypeTemplateRelations: arr.filter(
              (item) => item.DeviceTab !== 'DocumentInformation'
            ),
            device_TypeTemplateDocumentations: arr.filter(
              (item) => item.DeviceTab === 'DocumentInformation'
            ),
          }
        )
        .then((res) => {
          if (res.Success) {
            this.loading = false
            this.$notify.success('保存成功')
            this.$emit('save')
          } else {
            this.$notify.error('保存失败')
          }
        })
    },
    //获取模板左侧字段列表
    async getTemplateList(DeviceType) {
      this.loading = true
      await this.$http
        .post(
          `/Device_TypeWork/Device_TypeCorresponding/Getssdssd?DeviceType=${DeviceType}&DeviceTab=${this.activeName}`
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.leftData = res.Data || []
            this.leftDataCopy = JSON.parse(JSON.stringify(res.Data))
          }
        })
    },
    //选择分类
    async changeCascader() {
      this.ItemInfo = {}
      this.leftData = []
      this.leftDataCopy = []
      this.infoObj = {}
      this.activeName = ''
      await this.getDeviceTabList(this.ClassifyValue)
      this.getTemplateInfo(this.ClassifyValue)
    },
    leftDataSearch(a) {
      this.leftData = this.leftDataCopy.filter((item) => {
        return item.FieldName.indexOf(a) != -1
      })
    },
    itemSortSave() {
      this.infoObj[this.activeName] = this.infoObj[this.activeName].sort(
        (a, b) => {
          return a.sortIndex - b.sortIndex
        }
      )
    },
    //保存文档排序
    SortSubDocument() {
      console.log(
        this.ItemInfo?.device_TypeTwoDocuments,
        'this.ItemInfo?.device_TypeTwoDocuments'
      )
      this.ItemInfo.device_TypeTwoDocuments =
        this.ItemInfo.device_TypeTwoDocuments.sort((a, b) => {
          return a.Sort - b.Sort
        })
    },
    //删除字段
    itemDetele() {
      this.infoObj[this.ItemInfo.DeviceTab].splice(
        this.infoObj[this.ItemInfo.DeviceTab].findIndex((val) => {
          return val.FiledKey === this.ItemInfo.FiledKey
        }),
        1
      )
      this.ItemInfo = {}
    },
    //添加字段
    addItem(item) {
      console.log(this.infoObj[item.DeviceTab])
      if (!this.infoObj[item.DeviceTab]) {
        this.$set(this.infoObj, item.DeviceTab, [])
      }
      let obj = this.infoObj[item.DeviceTab].find((val) => {
        return val.FiledKey === item.FiledKey
      })
      if (obj) {
        this.ItemInfo = obj
      } else {
        if (item.DeviceTab === 'DocumentInformation') {
          this.$set(item, 'width', 1)
          this.$set(item, 'checked', false)

          this.$set(
            item,
            'device_TypeTwoDocuments',
            item.device_TypeTwoDocuments.map((val) => ({
              ...val,
              IsUpStatus: false,
              disabled: 0,
            }))
          )
          this.$set(
            item,
            'cList',
            item.device_TypeTwoDocuments.map((val) => val.Type)
          )
        } else {
          this.$set(item, 'width', 3)
        }
        console.log(item, '2222')
        this.$set(item, 'rows', 1)
        this.$set(item, 'disabled', item.IsEnable ? 1 : 0)
        this.$set(item, 'value', undefined)
        this.infoObj[item.DeviceTab].push(item)
        this.ItemInfo = item
      }

      console.log(this.ItemInfo,'this.ItemInfothis.ItemInfo')
    },
    getClassify() {
      this.$http
        .post(
          '/Base_ProjectManage/Project_Building/GetEquipmentClassificationDataList',
          {
            Search: {
              Condition: 'ProjectId',
              Keyword: this.ProjectId,
            },
          }
        )
        .then((res) => {
          if (res.Success) {
            this.Classify = res.Data[0].children
          } else {
            this.Classify = []
          }
        })
    },
    //获取选项卡信息
    async getDeviceTabList(DeviceType) {
      this.loading = true
      await this.$http
        .post(
          `/Device_TypeWork/Device_TypeCorresponding/GetDeviceTabDataList?DeviceType=${DeviceType}`
        )
        .then(async (res) => {
          this.loading = false
          if (res.Success) {
            this.DeviceTabList = res.Data
            //如未添加选项卡则清空模板
            if (res.Data.length > 0) {
              this.activeName = this.DeviceTabList[0].DeviceTab
              await this.getTemplateList(DeviceType)
            } else {
              this.activeName = ''
              this.infoObj = {}
              this.leftData = []
              this.leftDataCopy = []
              this.ItemInfo = {}
            }
            //初始化建立信息对象
          }
        })
    },

    getInfo() {
      this.$http
        .post('/Base_ProjectWork/Base_Project/GetTheData', {
          id: this.ProjectId,
        })
        .then((res) => {
          if (res.Success) {
            this.ProjectInfo = res.Data
          }
        })
    },

    treeSearch() {
      this.$refs.mytree.filter(this.filterText)
    },
    filterNode(value, data) {
      console.log(value, data, 'value,data')
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    //文件超出个数限制时的钩子
    handleExceed() {},
    //点击文件列表中已上传的文件时的钩子
    handlePreview() {},
    //文件列表移除文件时的钩子
    handleRemove() {},
    //TABS切换
    handleClick(val) {
      console.log(val.name)
      this.activeName = val.name
      if (this.ClassifyValue) {
        this.ItemInfo = {}
        this.getTemplateList(this.ClassifyValue)
      }
    },
    selectChange(value) {
      console.log(value)
      console.log(
        this.RightSeletData.filter((item) => {
          return value.indexOf(item.key) != -1
        })
      )
    },
    handleNodeClick(treeInfo) {
      console.log(treeInfo)
      this.RightInfo = treeInfo
    },
  },
  mounted() {},
  created() {
    console.log(this.$route.query, '222222222222')
    // this.openDesignPattern();
    // this.ProjectId = this.$route.query.Id || "";
    // this.ClassifyValue = this.$route.query.TreeId || "";
    // this.TreeName = this.$route.query.TreeName || "";
    // if (this.ProjectId && this.ClassifyValue) {
    //   this.getInfo();
    //   this.changeCascader();
    //   this.getIsEnableData();
    //   // this.getClassify();
    // }
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #409eff;
  color: #fff;
  font-weight: bold;
}

::v-deep .itemForm .el-form-item {
  margin-bottom: 0;
}

// ::v-deep .el-textarea__inner {
//   font-family: Arial, Helvetica, sans-serif !important;
// }
.active {
  border: 1px solid #409eff;
  border-radius: 4px;
  box-sizing: border-box;
}
.ButtonActive {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
::v-deep .el-table th .cell {
  font-weight: bold;
  font-size: 14px;
  color: #000000;
}
::v-deep .el-drawer__header {
  display: none;
}
.deviceFoundation {
  position: absolute;
  right: 10px;
  color: #e6a23c;
}
</style>
